var render, staticRenderFns
import script from "./GetJson.vue?vue&type=script&lang=ts&"
export * from "./GetJson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7feaf44')) {
      api.createRecord('c7feaf44', component.options)
    } else {
      api.reload('c7feaf44', component.options)
    }
    
  }
}
component.options.__file = "src/components/GetJson.vue"
export default component.exports